// extracted by mini-css-extract-plugin
export default {"container":"AboutMe_container__AJGLa","copy":"AboutMe_copy__Uhh1x","AboutVideo":"AboutMe_AboutVideo__Orifq"};